import styled from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  fontSize: theme.typography.size12,
  paddingBlock: '10rem',
}));

export const Information = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '8rem',
  width: '50%',
});

export const Title = styled.div(({ theme }) => ({
  fontSize: theme.typography.size14,
  textTransform: 'uppercase',
  marginBottom: '10rem',
}));
